import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47304654"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium mb-4 donate-detail-label" }, "Details", -1))
const _hoisted_2 = { class: "space-y-1 mb-4" }
const _hoisted_3 = { class: "detail--info" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-2" }, null, -1))
const _hoisted_6 = { class: "flex justify-between font-medium" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uppercase" }, "Total", -1))
const _hoisted_8 = { class: "text-primary" }

import { getDonationFees } from '@/apis';
import { Currency } from '@/types/Donate';
import { roundNumber } from '@/utils/numbers';
import { computed, reactive, watch } from 'vue';
import { numberWithCommas } from '@/composables/format';

interface Detail {
  title: string;
  value: string | number;
  noUnit?: boolean;
  border?: boolean;
}

interface Props {
  priceFor?: string;
  price?: number;
  amount?: number;
  symbol?: Currency;
  isFiat: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    priceFor: { default: 'item' },
    price: { default: 0 },
    amount: { default: 0 },
    symbol: { default: undefined },
    isFiat: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { priceFor: string, price: number, amount: number, symbol: Currency, isFiat: boolean }



const fees = reactive<{ operation: number; transaction: number }>({
  operation: 0,
  transaction: 0,
});
watch(
  () => ({ isFiat: props.isFiat, currency: props.symbol }),
  async ({ isFiat, currency }) => {
    if (isFiat) {
      const { data } = await getDonationFees(currency);
      fees.operation = data.feeAmount;
      fees.transaction = data.transactionFeePercentage / 100;
    } else {
      fees.operation = 0;
      fees.transaction = 0;
    }
  },
  { immediate: true }
);

const subtotal = computed(() => {
  return roundNumber(props.amount * props.price);
});

const transactionFee = computed(() => {
  return roundNumber(subtotal.value * fees.transaction);
});

const total = computed(() => {
  const allTotal = fees.operation + subtotal.value + transactionFee.value;
  return roundNumber(allTotal);
});

const details = computed<Detail[]>(() =>
  [
    {
      title: 'Price',
      value: numberWithCommas(subtotal.value),
    },
    {
      title: 'Operations fee',
      value: numberWithCommas(fees.operation),
      // isFiat: true,
      border: true,
    },
    {
      title: 'Subtotal',
      value: numberWithCommas(subtotal.value),
      isFiat: true,
    },
    {
      title: 'Transaction fee 4%',
      value: numberWithCommas(transactionFee.value),
      isFiat: true,
    },
  ].filter(({ isFiat }) => (isFiat && props.isFiat) || isFiat == null)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(details), (detail) => {
        return (_openBlock(), _createElementBlock("div", {
          key: detail.title,
          class: _normalizeClass(["flex justify-between donate-detail-sub-label", { 'border-b pb-2': detail.border }])
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(detail.title), 1),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(detail.value) + " ", 1),
            (!detail.noUnit)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.symbol), 1))
              : _createCommentVNode("", true)
          ])
        ], 2))
      }), 128))
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(numberWithCommas)(_unref(total))) + " " + _toDisplayString(__props.symbol), 1)
    ])
  ]))
}
}

})